/* Brand mark — institutional French tricolor emblem.
   Three thin vertical bars (blue / ink / red) — sober reference to
   the official French tri-colour without imitating the official Marianne. */
export default function Logo({ className = "", size = 24 }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <rect x="4" y="3" width="3" height="18" rx="1" fill="#0F3173" />
      <rect x="10.5" y="3" width="3" height="18" rx="1" fill="#161A22" />
      <rect x="17" y="3" width="3" height="18" rx="1" fill="#C8102E" />
    </svg>
  );
}
